import * as React from 'react';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { NavLink, useLocation } from 'react-router-dom';
import { Container, Box } from '@mui/material';

import './AppBar.css';

//import WhiteFoundationLogo from '../../img/fps-blanco.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVirusCovid } from '@fortawesome/free-solid-svg-icons';

const pages = [
  {
    name: 'search',
    link: '',
    info: 'Go to search',
    paths: ['beacon', 'beacon/', '/'],
  },
  {
    name: 'about',
    link: 'about',
    info: 'Information about project',
    paths: ['about'],
  },
];

function ResponsiveAppBar() {
  const location = useLocation();

  const getClass = (page: any) => {
    for (let p of page.paths) {
      if (location.pathname.endsWith(p)) {
        return 'barLinkActive';
      }
    }
    return 'barLinkNoActive';
  };

  return (
    <AppBar className="navbar navHead" position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <FontAwesomeIcon icon={faVirusCovid} size="2x" className="logo" />
          <h1>Biomedical Data Integration demo</h1>
          <Box flexGrow={5} />
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'flex' } }}>
            {pages.map((page) => (
              <NavLink
                className={getClass(page)}
                key={page.name}
                /*style={({ isActive }) => (
                                { color: isActive ? '#007fff' : 'white'

                                }
                                )}*/
                title={page.info}
                to={`${process.env.PUBLIC_URL}/${page.link}`}
              >
                {' '}
                {page.name}
              </NavLink>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;
